import React from 'react'

const ReportingAnalysis = () => {
  return (
    <div className='mx-auto p-4'>
      ReportingAnalysis
    </div>
  )
}

export default ReportingAnalysis
